import { activityForModel } from './model_helpers'

export default function (models = []) {
  return models.map(activityForModel).filter(Boolean)
}
